<template>
  <v-card color="white" :style="totalsStyle" class="mt-4 mr-6">
    <v-card-title>
      {{$t('totals')}}
    </v-card-title>
    <v-card-text class="font-weight-bold pb-5 px-5">
      <v-row v-for="(ctt, index) in totals" :key="`ctt-${ctt.label}-${index}`" dense>
        <v-col>{{ctt.label}}</v-col>
        <v-col class="text-right">{{ctt.value}}</v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'CommittedTimberTotalsCard',

  props: {
    totals: {
      type: Array,
      required: true
    }
  },

  computed: {
    totalsStyle () {
      return {
        width: 'max(256px, min(330px, 100vw))'
      }
    }
  }
}
</script>
